<div class="po-detail-box">
    <div class="head-section col-md-12 no-padding-left">
        <div class="logo-section col-sm-7 col-md-7 no-padding-left">
            <div class="head-section ">
                <div class="logo">
                    <img class="img-responsive" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1552912698/favicon.png">
                </div>
                <div class="address">
                    <p class="company-name">Truventor AI & Robotics Pvt Ltd</p>
                    <p>Office no 201, Prithvi Icon</p>
                    <p>Pune, 411045, Maharashtra, India.</p>
                    <p>+91-8408008123, 8484024656</p>
                    <p>PAN:<span class="pan-no">232SDSD223</span></p>
                    <p>GSTIN:<span class="gstin-no">23123123123DSSADA</span></p>
                </div>
            </div>
            <div class="btn-data">
                <!-- <button class="btn download-file">Download File/DWG</button> -->
                <button class="btn download-file" (click)="goToBOMLink(purchaseOrder.id)">Download BOM</button>
                <button class="btn download-po" (click)="goToPOLink(purchaseOrder.id)">Download PO</button>
                <button class="btn download-po" (click)="downloadAllFilesZip(purchaseOrder.id)">DownLoad All Files</button>
            </div>
        </div>
        <div class="po-details col-sm-5 col-md-5">
            <h2>Purchase Order</h2>
            <p>PO-no: <span>{{purchaseOrder.order_code}}</span></p>
            <p>PO-Date: <span>{{purchaseOrder.issued_at}}</span></p>
            <p>Expected Delivery Details: <span>{{purchaseOrder.expected_delivery_date}}</span></p>
            <!-- <p><span>P.R Ref: PO/ABC20303</span></p>
            <p><span>P.R Date:14 Dec 2018</span></p> -->
        </div>

    </div>

    <div class="address-section top-margin-sm">
        <div class="bill-to">
            <p><span>TO</span></p>
            <p><span>{{purchaseOrder.company_details}}</span></p>
            <p>{{purchaseOrder.registered_address.address}}</p>
            <p>{{purchaseOrder.registered_address.city}} {{purchaseOrder.registered_address.pin_code}} {{purchaseOrder.registered_address.state}} {{purchaseOrder.registered_address.country}}</p>
            <p><span>GSTIN:</span></p>
            <br>
            <p><span>Contact Person:</span> {{purchaseOrder.contact_person_details.name}}</p>
            <p><span>Phone number :</span> {{purchaseOrder.contact_person_details.phone_number}}</p>
            <p><span>Email :</span> {{purchaseOrder.contact_person_details.email}}</p>
            <p><span>Quote Ref :</span> </p>
            <p><span>Date:</span> <p>
        </div>
        <div class="ship-to">
            <p><span>SHIP TO</span></p>
            <p><span>Truventor AI & Robotics Pvt Ltd</span></p>
            <p>office no 201, phrithvi icon, Baner, Pune 411045</p>
            <p>Maharashtra, India</p>
            <p><span>PAN:</span> 23123123123DSSADA</p>
            <p><span>GSTIN:</span> 23123123123DSSADA</p>
            <p><span>LUT ARN NO.</span> AD270319012161H (Dated 27.03.2019)</p>

            <br>
            <p><span>Contact Person:</span> Mr Pauras Shinde</p>
            <p><span>Phone number :</span>+91-8408008123</p>
            <p><span>Email :</span> pauras@truventor.com</p>
        </div>
    </div>

    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Sr No.</th>
                <th>Part Code</th>
                <th>Part Description</th>
                <th>Qty</th>
                <th>UOM</th>
                <th>Rate</th>
                <th *ngIf="purchaseOrder.is_cgst_applicable">CGST %</th>
                <th *ngIf="purchaseOrder.is_cgst_applicable">SGST %</th>
                <th *ngIf="!purchaseOrder.is_cgst_applicable">IGST %</th>
                <th>Amount</th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of purchaseOrder.vendor_order_items; let i = index">
                <td>{{i+1}}</td>
                <td><p>{{item.model_attributes.model_code}}</p>
                    <!-- <p><a (click)="downloadPartFile(purchaseOrder.id, item.id)">DownLoad File</a></p> -->
                </td>
                <td>
                    <p>{{item.model_attributes.file_name}}</p>
                    <p>Material:<span>{{item.material_attributes.name}}</span></p>
                    <p>Volume:<span>{{item.volume}}mm</span></p>
                    <p>Process:<span>{{item.print_process}}</span></p>
                    <p>HSN: <span>{{item.material_attributes.hsn_code}}</span></p>
                </td>
                <td>{{item.quantity}}</td>
                <td>Nos</td>
                <td>&#8377; {{item.item_rate}}</td>
                <td *ngIf="purchaseOrder.is_cgst_applicable">9%</td>
                <td *ngIf="purchaseOrder.is_cgst_applicable">9%</td>
                <td *ngIf="!purchaseOrder.is_cgst_applicable">18%</td>
                <td>&#8377; {{item.total_cost}}</td>
            </tr>
        </tbody>
    </table>

    <div class="col-sm-12 no-padding terms-n-cost">
        <div class="col-sm-7 no-padding terms">
            <h3>Terms and condition</h3>
            <p>1. Kindly confirm the PO on or before {{purchaseOrder.expiry_date}}. If you do not confirm before this date, it will auto rejected.</p>
            <p>2. Strictly dispatch the parts as per Expected Dispatch Date only. Deplay in the dispatch may attract penal fees.</p>
            <p>3. This is a computer generated PO and does not require a signature.</p>
            <p>4. Attach the Pre-dispatch inspection report with the invoice before delivering the parts to us.
            </p>
            <p>5. Materials to be handled and packed properly to avoid any damage, dents, scratch, deformation during processing and transit.</p>
            <p>6. Payment terms Net 60 Days.</p>
        </div>
        <div class="col-sm-5 no-padding top-margin cost-details">
               <div class="display-flex-lg ">
                   <p class="col-sm-6">Total</p>
                    <p class="col-sm-6">&#8377; {{purchaseOrder.vendor_order_items_total_cost}}</p>
                </div>
                 <div class="display-flex-lg">
                   <p class="col-sm-6">MOQ COST</p>
                    <p class="col-sm-6">&#8377; 0.00</p>
                </div>
                 <div class="display-flex-lg">
                   <p class="col-sm-6">Delivery Charges</p>
                    <p class="col-sm-6">&#8377; 0.00</p>
                </div> 
                <div class="display-flex-lg">
                   <p class="col-sm-6">Part GST</p>
                    <p class="col-sm-6">&#8377; {{purchaseOrder.total_taxes}}</p>
                </div>
                <div class="display-flex-lg">
                   <p class="col-sm-6">Shipping GST</p>
                    <p class="col-sm-6">&#8377; 0.00</p>
                </div>
                <div class="display-flex-lg grand-total">
                   <p class="col-sm-6">Grand Total</p>
                    <p class="col-sm-6">&#8377; {{purchaseOrder.grand_total}}</p>
                </div>
        </div>
    </div>
    
    <div class="col-sm-12 no-padding display-flex-lg footer">
        <div class="col-sm-5">
            <p>+91-8793738826 | partner.support@truventor.com</p>
        </div>
        <div class="col-sm-7">
            <div class="footer-btn-data ">
                <!-- <button class="btn download-file">Download File/DWG</button> -->
                <button class="btn download-file" (click)="goToBOMLink(purchaseOrder.id)">Download BOM</button>
                <button class="btn download-po" (click)="goToPOLink(purchaseOrder.id)">Download PO</button>
            </div>
        </div>
    </div>

</div>